import { render, staticRenderFns } from "./Navego.vue?vue&type=template&id=5602920b&scoped=true"
import script from "./Navego.vue?vue&type=script&lang=js"
export * from "./Navego.vue?vue&type=script&lang=js"
import style0 from "./Navego.vue?vue&type=style&index=0&id=5602920b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5602920b",
  null
  
)

export default component.exports